import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import style from './Page.module.scss';

function Page(
  { children, title, subtitle },
) {
  return (
    <div className={clsx(style.page)}>
      {
        title && (
        <div className={clsx(style.page__title)}>
          <h2 className={clsx(style.page__title__text)}>{title}</h2>
        </div>
        )
      }

      {
          subtitle && (
            <div className={clsx(style.page__subtitle)}>
              <h3 className={clsx(style.page__subtitle__text)}>{subtitle}</h3>
            </div>
          )
        }
      <div className={clsx(style.page__container)}>
        {children}
      </div>
    </div>
  );
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

Page.defaultProps = {
  subtitle: null,
  title: null,
};

export default Page;
